import { useInterval } from 'usehooks-ts';

// Track video progress with API calls at regular intervals
export const useHeartbeat = ({
  onHeartbeat,
  enabled,
  getTime,
}: {
  onHeartbeat?: (time: number) => void;
  enabled: boolean;
  getTime: () => number;
}) => {
  useInterval(
    () => {
      const position = getTime();
      console.log(position);
      if (position === undefined) return;

      const time = Math.floor(position || 0);

      onHeartbeat && onHeartbeat(time);
    },
    enabled
      ? parseInt(process.env.NEXT_PUBLIC_VIDEO_HEARTBEAT_TIME || '120000')
      : null,
  );
};
